export default __webpack_public_path__ + "media/images/Masto-L1-Firefox-c0724e3a02452b057339af09d8ee524b.png";